<button type="button" nbButton (click)="openChooseCatalogModal()" [size]="size">
  <tui-icon icon="list"/>
</button>
